/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPentagonIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-pentagon"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.67 21.32Q6.8 21.32 6.13 20.82Q5.45 20.32 5.17 19.52L2.25 10.75Q1.98 9.93 2.25 9.09Q2.52 8.25 3.25 7.75L10.47 2.67Q11.18 2.17 12 2.17Q12.82 2.17 13.53 2.67L20.75 7.75Q21.48 8.25 21.75 9.09Q22.02 9.93 21.75 10.75L18.82 19.52Q18.55 20.32 17.88 20.82Q17.2 21.32 16.32 21.32Z" fill={color} />
    </svg>
  );
}
